<template>
  <div id="nav">
    <!--Instead of using hard-coded paths we will use the names instead-->
    <!--<router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>-->
    <router-link :to="{name: 'TasksList'}">Tasks</router-link> |
    <router-link :to="{name: 'About'}">About</router-link>
  </div>
  <router-view/>
</template>

<style>

#app {
  width:90%;
  margin:auto;
  border:1px solid black;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
